import { render } from "./ServiceList.vue?vue&type=template&id=174704c5&scoped=true"
import script from "./ServiceList.vue?vue&type=script&lang=js"
export * from "./ServiceList.vue?vue&type=script&lang=js"

import "./ServiceList.vue?vue&type=style&index=0&id=174704c5&lang=scss&scoped=true"

import exportComponent from "/proyectos/vue_institucional/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-174704c5"]])

export default __exports__